// extracted by mini-css-extract-plugin
export default {"container":"Yq-z","ratingLayout":"Zq-z","ratingLabel":"_q-z","nonInteractiveRatingLabel":"ar-z"};